import axios from 'axios';
import API_BASE_URL from '../config/api';

const authService = {
  applySession(token, user) {
    if (!token || !user) {
      throw new Error('Both token and user are required');
    }
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
  },

  async login(email, password) {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, {
        email,
        password
      });
      
      if (response.data.token) {
        this.applySession(response.data.token, response.data.user);
      }
      
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Login failed';
    }
  },

  async forgotPassword(email) {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/forgot-password`, { email });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to request password reset';
    }
  },

  async resetPassword(token, newPassword) {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/reset-password`, { token, newPassword });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to reset password';
    }
  },

  async logout() {
    const token = localStorage.getItem('token');
    const clearSession = () => {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    };

    if (!token) {
      clearSession();
      return;
    }

    const logoutRequest = axios.post(
      `${API_BASE_URL}/auth/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const timeout = new Promise((_, reject) => {
      setTimeout(() => reject(new Error('logout timeout')), 1500);
    });

    try {
      await Promise.race([logoutRequest, timeout]);
    } catch (error) {
      // Logout logging should never block client-side logout.
    } finally {
      clearSession();
    }
  },

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  setCurrentUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
  },

  getToken() {
    return localStorage.getItem('token');
  },

  isAuthenticated() {
    return !!this.getToken();
  }
};

export default authService;
